import React, { useEffect, useState } from "react";
import ContentPage from "../Components/ContentPage";
import SysGuardHeader from "../../SysGuardHeader";
import DataTable from "../Components/DataTable";
import {
  ENTRA,
  GOOGLEWORKSPACE,
  tableData,
} from "../../../../redux/constants/constants";
import Page_Loader from "../../../../assets/vizr_images/page_loader.gif";
import { useDispatch, useSelector } from "react-redux";
import {
  FETCH_ALL_SYS_GUARD_DATA_SOURCES,
  GET_SYS_GUARD_APPLICATION,
  GET_SYS_GUARD_LOCATION,
  GET_SYS_GUARD_USERS,
  GET_SYS_GUARD_HEADER_DATA,
  CLEAR_SYS_GUARD_TABLE_DATA,
  SET_REPORT_INCIDENT_DETAILS,
  SYS_GUARD_APPLICATION_NAMES_LIST,
  SYS_GUARD_COUNTRIES_LIST,
  GET_UNIQUE_USER_LIST,
  CLEAR_SYS_GUARD_FILTERS,
  FETCH_USER_TYPE_LIST,
  FETCH_USER_STATUS_LIST,
} from "../../sysGuardConstants";
import { isNull } from "lodash";
import ManagePopup from "../../Popups/ManagePopup";
import { useSysGuardDataSource } from "../../SysGuardCommonComp";

function SysGuardContent(props) {
  const selectedCategory = props.match.params.name;
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(100); //Just for this release making default size to 100
  const [popupDetails, setPopupDetails] = useState({});
  const [popupOpen, setPopupOpen] = useState(false);
  const loader = useSelector((state) => state.SysGuardReducer.sysGuardTableLoader);
  const setSelectedCategory = (selected) => {
    props.history.push(`/mdr/sysguard/content/${selected}`);
  };
  const sysGuardData = useSelector(
    (state) => state.SysGuardReducer.sysGuardDataSource
  );
  const fromTimeStamp = useSelector(
    (state) => state.SysGuardReducer.fromTimeStamp
  );
  const alertUpdated = useSelector((state) => state.alertStatusChanged.alertUpdated);
  const toTimeStamp = useSelector((state) => state.SysGuardReducer.toTimeStamp);
  const tableData = useSelector(
    (state) => state.SysGuardReducer.sysGuardTableData
  );
  const totalElements = useSelector(
    (state) => state.SysGuardReducer.totalElements
  );
  const isIncognito = useSelector((state) => state.SysGuardReducer.incognito);
  const selectedDatasourceID = useSelector(
    (state) => state.SysGuardReducer.selectedDatasourceID
  );
  const dispatch = useDispatch();

  const dataNotAvailable = () => {
    return isNull(sysGuardData) || !sysGuardData || Object.keys(sysGuardData).length === 0
  }

  useEffect(() => {
    if (dataNotAvailable()) {
      dispatch({ type: FETCH_ALL_SYS_GUARD_DATA_SOURCES });
    }
  }, [selectedDatasourceID]);

  useEffect(() => {
    if (!dataNotAvailable() || alertUpdated) {
      const id = selectedDatasourceID.join(",");
      const actionTypes = {
        Locations: GET_SYS_GUARD_LOCATION,
        Users: GET_SYS_GUARD_USERS,
        Applications: GET_SYS_GUARD_APPLICATION,
      };
      const getListTypes = {
        Applications: [SYS_GUARD_APPLICATION_NAMES_LIST, SYS_GUARD_COUNTRIES_LIST],
        Locations: [SYS_GUARD_COUNTRIES_LIST],
        Users: [GET_UNIQUE_USER_LIST, FETCH_USER_TYPE_LIST, FETCH_USER_STATUS_LIST],
      }
      dispatch({ type: GET_SYS_GUARD_HEADER_DATA, payload:{loc: "content"} });
      if (actionTypes[selectedCategory]) {
        dispatch({
          type: actionTypes[selectedCategory],
          payload: { currentPage, pageSize, id, isIncognito },
        });
      }
      if (getListTypes[selectedCategory]) {
        getListTypes[selectedCategory].forEach((type) => {
          dispatch({
            type,
            payload: { dataSourceId: id, fromTimeStamp, toTimeStamp },
          });
        });
      }
    }
  }, [
    selectedCategory,
    fromTimeStamp,
    toTimeStamp,
    currentPage,
    pageSize,
    sysGuardData,
    isIncognito,
    alertUpdated,
    selectedDatasourceID
  ]);

  useEffect(() => {
    dispatch({ type: CLEAR_SYS_GUARD_TABLE_DATA });
    dispatch({ type: CLEAR_SYS_GUARD_FILTERS });
  }, [selectedCategory]);

  useEffect(() => {
    dispatch({ type: SET_REPORT_INCIDENT_DETAILS, payload: null });
  },[])

  return (
    <div>
      {loader && (
        <img src={Page_Loader} alt="loading" className="sysGuardLoader"></img>
      )}
      <div className="sys-guard guard-content">
        <SysGuardHeader />
        <ContentPage
          selected={selectedCategory}
          setSelected={setSelectedCategory}
        />
        <div className="sys-guard-data-table">
          <DataTable
            data={tableData}
            totalElements={totalElements}
            type={selectedCategory}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            setPopupDetails={setPopupDetails}
            setPopupOpen={setPopupOpen}
            dataSourceType={sysGuardData?.type?.code}
            dataSourceId={selectedDatasourceID.join(",")}
            loc={selectedCategory}
          />
        </div>
      </div>
      <ManagePopup
        popupDetails={popupDetails}
        popupOpen={popupOpen}
        setPopupOpen={setPopupOpen}
      />
    </div>
  );
}

export default SysGuardContent;
